module.exports = __webpack_public_path__ + "img/intercomBanner.971d81ba.png";